import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=235e5dc1&scoped=true"
import script from "./Buttons.vue?vue&type=script&lang=ts"
export * from "./Buttons.vue?vue&type=script&lang=ts"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=235e5dc1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e5dc1",
  null
  
)

export default component.exports